import { gql } from 'graphql-request';

import linkAccountPage from './linkAccountPage';
import registerPage from './registerPage';
import termsPage from './termsPage';

const plusQuery = gql`query Plus {
  ${registerPage}
  ${termsPage}
  ${linkAccountPage}
}`;

export default plusQuery;
